import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=27387c86&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=27387c86&scoped=true&lang=css&"
import style1 from "./todo.vue?vue&type=style&index=1&id=27387c86&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27387c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27387c86')) {
      api.createRecord('27387c86', component.options)
    } else {
      api.reload('27387c86', component.options)
    }
    module.hot.accept("./todo.vue?vue&type=template&id=27387c86&scoped=true&", function () {
      api.rerender('27387c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/costentry/components/todo.vue"
export default component.exports